<template>
  <div>
    <div id="circle">
      <canvas :id="this.bindEl"></canvas>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    Proportion: {
      default: 0
    },
    bindEl: {
      type: String,
      default: "my_html"
    }
  },
  methods: {
    MyProgress(init) {
      this.init(init);
    },
    init(init) {
      this.el = init.el; //元素ID
      let cvsElement = document.getElementById(this.el), //获取元素
        ctx = cvsElement.getContext("2d"), //获取画笔
        width = 140, //元素宽度
        height = 140, //元素高度
        degActive = 0, //动态线条
        degActive1 = 0, //动态线条
        timer = null; //定时器
      //停止时的角度
      init.deg = parseInt(init.deg);
      init.deg > 0 ? (this.deg = init.deg) : (this.deg = 0);

      //线宽
      init.lineWidth !== undefined
        ? (this.lineWidth = init.lineWidth)
        : (this.lineWidth = 20);

      //判断宽高较小者
      this.wh = width > height ? height : width;

      //设置圆的半径，默认为宽高较小者
      init.circleRadius > 0 &&
      init.circleRadius <= this.wh / 2 - this.lineWidth / 2
        ? (this.circleRadius = init.circleRadius)
        : (this.circleRadius = this.wh / 2 - this.lineWidth / 2);

      //绘制线的背景颜色
      init.lineBgColor !== undefined
        ? (this.lineBgColor = init.lineBgColor)
        : (this.lineBgColor = "#ccc");

      //绘制线的颜色
      init.lineColor !== undefined
        ? (this.lineColor = init.lineColor)
        : (this.lineColor = "#009ee5");

      //绘制文字颜色
      init.textColor !== undefined
        ? (this.textColor = init.textColor)
        : (this.textColor = "#009ee5");

      //绘制文字大小
      init.fontSize !== undefined
        ? (this.fontSize = init.fontSize)
        : (this.fontSize = parseInt(this.circleRadius / 2));

      //执行时间
      this.timer = init.timer;

      //清除锯齿
      if (window.devicePixelRatio) {
        cvsElement.style.width = width + "px";
        cvsElement.style.height = height + "px";
        cvsElement.height = height * window.devicePixelRatio;
        cvsElement.width = width * window.devicePixelRatio;
        ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
      }
      //设置线宽
      ctx.lineWidth = this.lineWidth;
      //启动定时器
      timer = setInterval(
        function() {
          ctx.clearRect(0, 0, width, height); //清除画布
          ctx.beginPath(); //开始绘制底圆
          ctx.arc(width / 2, height / 2, this.circleRadius, 1, 8);
          ctx.strokeStyle = this.lineBgColor;
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = 0;
          ctx.shadowColor = "rgba(0,0,0,0.30);";
          ctx.shadowBlur = 20;
          ctx.stroke();

ctx.beginPath(); //开始绘制动态圆
if(init.deg>100){
          ctx.arc(
            width / 2,
            height / 2,
            this.circleRadius+11,
            -Math.PI / 2,
            (parseFloat(degActive/100)*30 * Math.PI) / 180 - Math.PI / 2,
            false
          );
          ctx.strokeStyle = "rgba(229,229,229,0.70);";
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = -10;
          ctx.shadowColor = "rgba(0,0,0,0.30)";
          ctx.shadowBlur = 10;
          var g = ctx.createLinearGradient(0, 90, 180, 200); //创建渐变对象  渐变开始点和渐变结束点
          g.addColorStop(0, "#C04A4A"); //添加颜色点
          g.addColorStop(1, "#E6BA84"); //添加颜色点
          ctx.strokeStyle = g; //使用渐变对象作为圆环的颜色
          ctx.lineWidth = this.lineWidth;
          ctx.lineCap="round";
          ctx.stroke();
       }  
            ctx.beginPath(); //开始绘制动态圆
          ctx.arc(
            width / 2,
            height / 2,
            this.circleRadius,
            -Math.PI / 2,
            (degActive * Math.PI) / 180 - Math.PI / 2,
            false
          );
          ctx.strokeStyle = "rgba(229,229,229,0.70);";
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = -5;
          ctx.shadowColor = "rgba(0,0,0,0.30)";
          ctx.shadowBlur = 10;
          var g = ctx.createLinearGradient(0, 90, 90, 185); //创建渐变对象  渐变开始点和渐变结束点
          g.addColorStop(0, "#C04A4A"); //添加颜色点
          g.addColorStop(1, "#E6BA84"); //添加颜色点
          ctx.strokeStyle = g; //使用渐变对象作为圆环的颜色
          ctx.lineWidth = this.lineWidth;
          ctx.lineCap="round";
          ctx.stroke();
         

        
         
          
          let txt = Math.round((degActive * 100) / 360) + "%"; //获取百分比
          ctx.font = this.fontSize + "px SimHei";
          let w = ctx.measureText(txt).width; //获取文本宽度
          let h = this.fontSize / 2;
          ctx.fillStyle = this.textColor;
          ctx.fillText(txt, width / 2 - w / 2, height / 2 + h / 2);
       
          if (degActive >= (this.deg / 100) * 360) {
            //停止定时器
            clearInterval(timer);
            timer = null;
          }
          degActive++;
        }.bind(this),
        this.timer
      );
      
    }
  },
  mounted() {
    this.MyProgress({
      el: this.bindEl, //canvas元素id
      deg: Math.round(parseFloat(this.Proportion)), //绘制角度
      timer: 5, //绘制时间
      lineWidth: 12, //线宽
      lineBgColor: "rgba(229,229,229,0.70)", //底圆颜色
      lineColor: "rgba(229,229,229,0.70);", //动态圆颜色
      textColor: "#181818", //文本颜色
      fontSize: 20, //字体大小
      circleRadius: 40, //圆半径
      myTxt: Math.round(parseFloat(this.Proportion))
    });
  },
  watch: {
    Proportion: function(newData, oldData) {
      
      this.Proportion = newData;
      this.MyProgress({
        el: this.bindEl, //canvas元素id
        deg: Math.round(parseFloat(this.Proportion)), //绘制角度
        timer: 5, //绘制时间
        lineWidth: 12, //线宽
        lineBgColor: "rgba(229,229,229,0.70)", //底圆颜色
        lineColor: "rgba(229,229,229,0.70);", //动态圆颜色
        textColor: "#181818", //文本颜色
        fontSize: 20, //字体大小
        circleRadius: 40, //圆半径
        myTxt: parseInt(newData)
      });
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/public/circular.vue